import React, { useState, useEffect } from 'react';

const MessageBox = ({ isDisabled, onClick, showNotification }) => {
  const [showTooltip, setShowTooltip] = useState(false);
  const [isChatReady, setIsChatReady] = useState(false);
  const [isChatOpen, setIsChatOpen] = useState(false);

  useEffect(() => {
    // Hide Zoho's default floating button
    const hideZohoDefault = setInterval(() => {
      const defaultWidget = document.getElementById('zsiq_float');
      if (defaultWidget) {
        defaultWidget.style.display = 'none';
        clearInterval(hideZohoDefault);
      }
    }, 200);

    // Wait for Zoho API to be ready
    const checkZohoReady = setInterval(() => {
      if (
        window.$zoho &&
        window.$zoho.salesiq &&
        typeof window.$zoho.salesiq.floatwindow?.visible === 'function'
      ) {
        setIsChatReady(true);
        clearInterval(checkZohoReady);
      }
    }, 300);

    return () => {
      clearInterval(hideZohoDefault);
      clearInterval(checkZohoReady);
    };
  }, []);

  const handleClick = () => {
    onClick?.();

    if (!isChatReady) {
      console.warn('Zoho SalesIQ not ready yet.');
      return;
    }

    try {
      if (isChatOpen) {
        window.$zoho.salesiq.floatwindow.visible('hide');
        setIsChatOpen(false);
      } else {
        window.$zoho.salesiq.floatwindow.visible('show');
        setIsChatOpen(true);
      }
    } catch (error) {
      console.error('Error toggling Zoho chat:', error);
    }
  };

  return (
    <div
      style={{ position: 'relative', display: 'inline-block' }}
      onMouseEnter={() => setShowTooltip(true)}
      onMouseLeave={() => setShowTooltip(false)}
    >
      {showTooltip && (
        <div style={{
          position: 'absolute', top: '50%', right: '110%',
          transform: 'translateY(-50%)', backgroundColor: 'black',
          color: 'white', padding: '6px 10px', borderRadius: '5px',
          fontSize: '12px', whiteSpace: 'nowrap', zIndex: 999
        }}>
          Chat/Call
          <div style={{
            position: 'absolute', top: '50%', left: '100%',
            transform: 'translateY(-50%)', width: 0, height: 0,
            borderTop: '6px solid transparent', borderBottom: '6px solid transparent',
            borderLeft: '6px solid black'
          }} />
        </div>
      )}

      <button
        onClick={handleClick}
        disabled={isDisabled || !isChatReady}
        style={{
          background: 'none', border: 'none', cursor: 'pointer',
          opacity: isDisabled || !isChatReady ? 0.4 : 1, position: 'relative'
        }}
      >
        <img
          src={`${process.env.PUBLIC_URL}/assets/images/chat-call.svg`}
          alt="chat-call"
          style={{ width: 18, height: 18 }}
        />
        {showNotification && (
          <div style={{
            position: 'absolute', top: 0, right: 0, width: 8, height: 8,
            backgroundColor: 'red', borderRadius: '50%',
            boxShadow: '0 0 2px rgba(0,0,0,0.3)'
          }} />
        )}
      </button>
    </div>
  );
};

export default MessageBox;
